export const questionniareEndPoint = `questionnaire`;
export const videoRecordingsEndPoint = `video-recordings`;
